import { useDataChange } from 'Simple/Data.js'
import { equals } from 'Data/aggregate.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.apps_filter',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change('directory')
  }
}

export function getText(value, defaultText) {
  return value ? `${defaultText} (1 selected)` : defaultText
}

export function getSelected(value, tab) {
  if (value === null) return true

  return equals(value, tab)
}
